import React from 'react';
import { Form } from 'react-bootstrap';

const SelectComponent = ({
  options,
  nameField,
  valueField,
  selectedValue,
  handleChange,
  controlId,
  label,
  required = false,
  defaultOptionLabel = 'Seleccione',
  insertValueField,             // opcional: otro campo para value
  feedbackInvalid = 'Este campo es obligatorio.',
  feedbackValid,                // opcional
  onBlur,
  className,
  style
}) => {
  return (
    <Form.Group controlId={controlId} className="mb-3">
      {label && <Form.Label>{label}</Form.Label>}

      {/* Usa Form.Select (renderiza class="form-select") */}
      <Form.Select
        name={controlId}
        value={selectedValue ?? ''}   // controla vacío como ''
        onChange={handleChange}
        onBlur={onBlur}
        required={required}
        className={className}
        style={style}
        aria-label={label || controlId}
      >
        {/* placeholder deshabilitado para que required falle si queda aquí */}
        <option value="" disabled>{defaultOptionLabel}</option>

        {options.map(opt => (
          <option
            key={opt[valueField]}
            value={insertValueField ? opt[insertValueField] : opt[valueField]}
          >
            {opt[nameField]}
          </option>
        ))}
      </Form.Select>

      {/* Mensajes de feedback de Bootstrap */}
      {/* {feedbackInvalid && (
        <Form.Control.Feedback type="invalid">
          {feedbackInvalid}
        </Form.Control.Feedback>
      )}
      {feedbackValid && (
        <Form.Control.Feedback type="valid">
          {feedbackValid}
        </Form.Control.Feedback>
      )} */}
    </Form.Group>
  );
};

export default SelectComponent;
